import { selectionStore } from "@/features/widgets/components/Selection/utils/selectionStore.tsx";

class SelectionHelper {

  public static WIDGET_TYPE_BUTTON_SELECT = `button-select`;

  public static initialize = () => {
  }

  public static initializeWidget = (widget: HTMLElement, type: string) => {
    switch (type) {
      case this.WIDGET_TYPE_BUTTON_SELECT: {
        widget.addEventListener(
          `click`,
          () => {
            const categoryId = widget.getAttribute(`data-ws-category-id`);
            const dialogTitle =  widget.getAttribute(`data-ws-dialog-title`);

            selectionStore.start(
              categoryId ? parseInt(categoryId) : null,
              dialogTitle || null,
              );
          }
        )
        break;
      }
    }
  }

}

export default SelectionHelper;
